import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import Pane from '@/component/Layout/PaneFixedHeader';
import { useTexts } from '@/feature/lang';
import { DocumentTitle } from '@/view/app/routing/DocumentTitle';
import {
  activitiesPath,
  alarmsPath,
  basicsPath,
  discoverDataPath,
  equipmentDashboardPath,
  equipmentDataPath,
  equipmentPartsPath,
  insightsPath,
  noticeBoardPath,
} from '../pathDefinitions';
import EquipmentListSkeleton from './components/EquipmentList/EquipmentListSkeleton';
import { Layout } from './components/Layout';
import Details from './pages/Details';
import { useSelection } from './selection/SelectionContext';

const EquipmentListPane = lazy(
  () => import('./components/EquipmentList/EquipmentListPane')
);

const FleetOverview = () => (
  <>
    <FleetDocumentTitle />
    <Layout
      list={
        <Suspense fallback={<EquipmentListSkeleton />}>
          <EquipmentListPane />
        </Suspense>
      }
      main={<DetailsPane />}
      breakpoints={{
        medium: {
          maxWidth: 899,
        },
        large: {
          minWidth: 900,
          maxWidth: 1599,
        },
        xlarge: {
          minWidth: 1600,
        },
      }}
      domain="fleet-equipment"
    />
  </>
);

export default FleetOverview;

const FleetDocumentTitle = () => {
  const { fleet, app } = useTexts();

  return (
    <Routes>
      <Route path="/" element={<DocumentTitle />} />
      <Route
        path={equipmentDashboardPath}
        element={<DocumentTitle title={fleet.dashboard.header} />}
      />
      <Route
        path={equipmentDataPath}
        element={<DocumentTitle title={fleet.data.header} />}
      />
      <Route
        path={discoverDataPath}
        element={<DocumentTitle title={fleet.discover.header} />}
      />
      <Route
        path={alarmsPath}
        element={<DocumentTitle title={fleet.alarms.header} />}
      />
      <Route
        path={insightsPath}
        element={<DocumentTitle title={fleet.insights.header} />}
      />
      <Route
        path={noticeBoardPath}
        element={<DocumentTitle title={fleet.noticeBoard.header} />}
      />
      <Route
        path={activitiesPath}
        element={<DocumentTitle title={fleet.activity.header} />}
      />
      <Route
        path={basicsPath}
        element={<DocumentTitle title={fleet.basics.header} />}
      />
      <Route
        path={equipmentPartsPath}
        element={<DocumentTitle title={fleet.partsCatalog.header} />}
      />
      <Route
        path="*"
        element={<DocumentTitle title={app.routing.notFound.title} />}
      />
    </Routes>
  );
};

const DetailsPane = () => {
  const { selected } = useSelection();

  return (
    <Pane>
      <Details equipmentIds={selected} />
    </Pane>
  );
};
